'use strict';
  
angular.module('buyersService')
.factory('SellerService', ['appInfo', '$log', '$rootScope' ,'$http', '$q', 'CacheFactory', 
    function (appInfo, $log, $rootScope, $http, $q, CacheFactory) {
        var service = {}
        , code    = $rootScope.currentUser.authdata
        , expires =  moment().add(15, 'm').unix();

        var userCache;
        
        if (!CacheFactory.get('sellerCache')) {
          sellerCache = CacheFactory('sellerCache', { maxAge: 15 * 60 * 1000, deleteOnExpire: 'aggressive' });
        }

        service.update = function (usercode, user) {
            var dfd = $q.defer();

            $http({
                url: appInfo.endpoint+'otherusers/updateseller.json', 
                method: "GET",
                params: {usercode: usercode, api_key: appInfo.key, email: user.info.email, mobile: user.info.mobile}
            }).success(function (data, status, headers, config){
                dfd.resolve(data);
            }).error(function(data, status, headers, config) {
                dfd.reject("Error: Unable to update. Status = " + status); 
            });

            return dfd.promise; 
        };
        
        service.listings = function (usercode) {
            var dfd = $q.defer();
            $http({
                url: appInfo.endpoint+'otherusers/mylistings.json', 
                method: "GET",
                params: {usercode: usercode, api_key: appInfo.key},
                cache: CacheFactory.get('sellerCache')
            }).success(function (data, status, headers, config){
                dfd.resolve(data);
            }).error(function(data, status, headers, config) {
                dfd.reject("Error: Unable to update. Status = " + status); 
            });

            return dfd.promise;   
        };
  
        service.property = function (usercode, ref) {
            var dfd = $q.defer();

            $http({
                url: appInfo.endpoint+'otherusers/property.json', 
                method: "GET",
                params: {usercode: usercode, ref: ref, api_key: appInfo.key},
                cache: CacheFactory.get('sellerCache')
            }).success(function(data) {
                dfd.resolve(data);
            }).error(function(data, status, headers, config) {
                dfd.reject("Error: request returned status " + status); 
            });

            return dfd.promise;
            
        };

        service.agent = function(usercode, identifier, contact) {
            var dfd = $q.defer();
            var params = (identifier !=='')? {usercode: usercode, identifier: identifier, api_key: api_key} :
                        {usercode: usercode, contact: contact, api_key: appInfo.key};

            $http({
                url: appInfo.endpoint+'otherusers/agent.json', 
                method: "GET",
                params: params,
                cache: CacheFactory.get('sellerCache')
            }).success(function(data) {
                dfd.resolve(data);
            }).error(function(data, status, headers, config) {
                dfd.reject("Error: request returned status " + status); 
            });

            return dfd.promise;
            
        };

        service.email = function () {
            
        };
  
        return service;
    }]);